export default __webpack_public_path__ + "static/media/search_banner_2.9fb6cf60.svg";